import { getDatabase, ref as dbRef, set, get } from 'firebase/database'
import { getApp } from 'firebase/app'
import { handleErrors } from '../utils/errorHandler'

const RTDB_PATH = 'AGENCY_DATA_UPDATES'

export const AgencyDataService = () => {
  const db = getDatabase(getApp())

  /**
   * Mark that agency data has been updated by writing a timestamp to Realtime DB.
   * Call this after any operation that modifies employer/plan year/answer data.
   * @param {string} agencyId - The agency ID
   */
  const markAgencyDataUpdated = async (agencyId) => {
    if (!agencyId) return
    try {
      const updateRef = dbRef(db, `${RTDB_PATH}/${agencyId}`)
      await set(updateRef, { last_updated: Date.now() })
    } catch (error) {
      handleErrors('AgencyDataService.markAgencyDataUpdated', error)
    }
  }

  /**
   * Get the last update timestamp for an agency from Realtime DB.
   * @param {string} agencyId - The agency ID
   * @returns {Promise<number|null>} The timestamp or null if not found
   */
  const getAgencyLastUpdated = async (agencyId) => {
    if (!agencyId) return null
    try {
      const updateRef = dbRef(db, `${RTDB_PATH}/${agencyId}`)
      const snapshot = await get(updateRef)
      if (snapshot.exists()) {
        return snapshot.val().last_updated || null
      }
      return null
    } catch (error) {
      handleErrors('AgencyDataService.getAgencyLastUpdated', error)
      return null
    }
  }

  return { markAgencyDataUpdated, getAgencyLastUpdated }
}
